import API from "../api";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async requestMiniExtract(): Promise<any> {
      const { data } = await API.getMiniExtract();
      return data;
    },
    async requestAbout(): Promise<any> {
      const { data } = await API.getAbout();
      return data;
    },
    async requestSurveyMonkey(context: any, payload: any): Promise<any> {
      const { data } = await API.getSurveyMonkey(payload);
      return data;
    },
    async requestAvailableItems(context: any, payload: any): Promise<any> {
      const { data } = await API.getAvailableItems(payload);
      return data;
    },
    async requestRedeemedItems(context: any, payload: any): Promise<any> {
      const { data } = await API.getRedeemedItems(payload);
      return data;
    },
    async requestProduct(context: any, payload: string): Promise<any> {
      const { data } = await API.getProduct(payload);
      return data;
    },
    async requestRedeemProduct(context: any, payload: string): Promise<any> {
      const { data } = await API.patchRedeemProduct(payload);
      return data;
    },
    async requestNewProduct(context: any, payload: any): Promise<any> {
      const { data } = await API.postProduct(payload);
      return data;
    },
    async requestEditProduct(context: any, payload: any): Promise<any> {
      const { data } = await API.putProduct(payload);
      return data;
    },
    async requestProductDetail(context: any, payload: string): Promise<any> {
      const { data } = await API.getProduct(payload);
      return data;
    },
  },
  modules: {},
};
